import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { IDispatchTruckTicket } from "src/Interfaces/DispatchInterface";
import PdfService from "src/Services/Pdf";
import { DispatchStore } from "src/Stores/Dispatch/DispatchStore";
import { UserStore } from "src/Stores/User/UserStore";

@inject('stores')
@observer
export default class DispatchTruckTicketPdf extends React.Component {
    public props: any;
    public UserStore: UserStore;
    public DispatchStore: DispatchStore;    

    public state = {
        truck: undefined as unknown as IDispatchTruckTicket
    };

    constructor(props: any) {
        super(props);

        this.UserStore = this.props.stores.UserStore;
        this.DispatchStore = this.props.stores.DispatchStore;
    }

    public componentDidMount() {
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
        
        if (this.props.match.params.type === 'pickup') {
            this.DispatchStore.getTruckTicketPickup(this.props.match.params.truckId)
                .then(truck => {
                    this.setState({truck});
                });
        } else {
            this.DispatchStore.getTruckTicketDelivery(this.props.match.params.truckId)
                .then(truck => {
                    this.setState({truck});
                });
        }
    }

    public componentDidUpdate() {
        this.renderIframe();
    }

    private renderIframe() {
        const myFrame: any = document.getElementById('my_frame');
        if (myFrame) {
            this.pdfReportString().then((data: any) =>
                myFrame.src = data
            );
        }
    }


    private pdfReportString = () => {
        return PdfService.createDispatchTruckTicket(this.state.truck);
    }

    public render() {
        if (this.state.truck === undefined ) {
            return (
                <FontAwesomeIcon 
                icon={faSpinner}
                spin={true}
                size={"8x"}
                style={{position: 'fixed', left: '50%', top: '35%'}}
            />
            );
        }
        return (
            <iframe id="my_frame" style={{width: '100%', height: '2000px'}} />
        );
    }


}


// WEBPACK FOOTER //
// ./src/Components/Reporting/DispatchTruckTicket.tsx